module.exports = __webpack_public_path__ + "img/bank-11-bs.3cfca22e.svg";